import React, { useEffect, useState } from 'react';
import { Collapse, Box, Typography, IconButton, Divider } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import PageHeaderNew from '../PageHeader/PageHeaderNew';
import Footer from '../../Login/Footer';
import { connect } from 'react-redux';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import { get, urlify, detectNextLine } from '../../../Utilities';
import BackdropLoader from '../BackdropLoader/BackdropLoader';
import './FAQ.scss';
import { PageHeader } from '../PageHeader/PageHeader';
import {
  getAppLanguage,
  getClientId,
  getLanguageObject,
} from '../../../redux/reducers/clientUserId.reducer';
import { useCallback } from 'react';

const FAQ = (props) => {
  const { branding, noHeading, history, noHeader = false, languageObject, appLanguage, clientId } = props;
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  const languagify = useCallback(
    (key, word) => {
      return languageObject[`${key}`] || word;
    },
    [languageObject],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    get({ language_id: appLanguage, client_id: clientId }, '/getFaqs').then((res) => {
      if (res && res.success) {
        setFaqs(res.result || []);
      }
      setLoading(false);
    });
  }, [appLanguage]);

  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  const faqClasses = {
    container: noHeader ? 'faq-container-noheader' : 'faq-container',
    heroContainer: 'faq-hero-container mt-5 mt-md-0',
    faqCard: 'faq-card',
    accordionButton: 'faq-button',
    faqCardNoHeader: 'faq-card-noheader',
    question: 'faq-question',
    answer: 'faq-answer',
    noFaqText: 'faq-no-faq',
  };

  if (loading && !noHeader) {
    return (
      <>
        <PageHeader
          customBack
          handleBack={() => history.goBack()}
          history={history}
          title={languagify('faqs_page_title', 'FAQs')}
        />
        <BackdropLoader isLoading={languagify('faqs_loading', 'Loading FAQs')} />
      </>
    );
  }

  return (
    <>
      {!noHeader && (
        <PageHeader
          
          customBack
          handleBack={() => history.goBack()}
          history={history}
          title={languagify('faqs_page_title', 'FAQs')}
        />
      )}

      {/* Hero Header */}
      {!noHeader && (
        <div className={faqClasses.heroContainer}>
          <div style={{ textAlign: 'center', zIndex: 1, padding: '0 20px' }}>
            <h1
              style={{
                fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                fontWeight: '800',
                color: 'white',
                marginBottom: '1rem',
                letterSpacing: '-0.5px',
                textShadow: '0 2px 20px rgba(0,0,0,0.2)',
              }}
            >
              {languagify('faqs_hero_heading', 'Frequently Asked Questions')}
            </h1>
            <p
              style={{
                fontSize: 'clamp(1rem, 2vw, 1.25rem)',
                color: 'rgba(255, 255, 255, 0.95)',
                maxWidth: '600px',
                margin: '0 auto',
                fontWeight: '400',
                lineHeight: '1.6',
              }}
            >
              {languagify(
                'faqs_hero_subheading',
                'Find answers to commonly asked questions about the platform',
              )}
            </p>
          </div>
        </div>
      )}
      {!noHeading && noHeader && faqs.length > 0 ? (
        <h5
          style={{ fontFamily: 'Montserrat-Bold' }}
          id='courses-section'
          className='pb-0 text-left fontBoldBold mx-0'
        >
          FAQs
        </h5>
      ) : null}
      <div className={faqClasses.container}>
        {faqs.length === 0 ? (
          !noHeader ? (
            <Typography variant='body1' className={faqClasses.noFaqText}>
              {languagify('faqs_empty', 'No FAQs available at the moment.')}
            </Typography>
          ) : null
        ) : (
          <Box className='faq-accordion-wrapper'>
            {faqs.map((faq, index) => (
              <Box key={index} className={noHeader ? faqClasses.faqCardNoHeader : faqClasses.faqCard}>
                <Box
                  className={faqClasses.accordionButton}
                  onClick={() => handleToggle(index)}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontFamily: 'Montserrat-Regular',
                    padding: '1.2rem',
                    cursor: 'pointer',
                  }}
                >
                  <Typography
                    variant='body1'
                    className={faqClasses.question}
                    sx={{ textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: urlify(faq.faq_question) }}
                  />

                  <IconButton
                    size='small'
                    sx={{
                      color: 'var(--primary-blue)',
                    }}
                  >
                    {openIndex === index ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Box>
                <Collapse
                  in={openIndex === index}
                  timeout='auto'
                  unmountOnExit
                  easing={{ entry: 'linear', exit: 'linear' }}
                >
                  <Box className='text-left' sx={{ padding: '0px 1.2rem 1.2rem 1.2rem' }}>
                    <Typography
                      variant='body2'
                      className={faqClasses.answer}
                      dangerouslySetInnerHTML={{ __html: detectNextLine(urlify(faq.faq_answer)) }}
                    />
                  </Box>
                </Collapse>
              </Box>
            ))}
          </Box>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  branding: getCurrentBranding(state),
  languageObject: getLanguageObject(state),
  appLanguage: getAppLanguage(state),
  clientId: getClientId(state),
});

export default connect(mapStateToProps)(FAQ);
